import { Injectable } from '@angular/core';

export interface MaterialEntryDraftProductOption {
  label: string;
  value: number;
  priceCost: number;
  code: string;
  description: string;
  measureUnityId: number;
}

export interface MaterialEntryDraft {
  activeStep: number;
  formValue: {
    principal?: {
      accessKey?: string;
      emissionDate?: string | null;
      emissionTime?: string;
      supplierId?: number | null;
    };
    items?: Array<{
      productId?: number | null;
      productCode?: string;
      productDescription?: string;
      quantity?: number;
      unitPrice?: number;
      discount?: number;
    }>;
    payments?: Array<{
      typePaymentId?: number | null;
      value?: number;
    }>;
    total?: {
      totalFreight?: number;
      totalInsurance?: number;
      totalOtherExpenses?: number;
      discountOnTotal?: number;
      observations?: string;
    };
  };
  productOptions: MaterialEntryDraftProductOption[];
}

const STORAGE_KEY = 'material-entry-draft';

@Injectable({
  providedIn: 'root'
})
export class MaterialEntryDraftService {

  saveDraft(data: MaterialEntryDraft): void {
    try {
      const json = JSON.stringify(data, (_, v) => (v instanceof Date ? v.toISOString() : v));
      sessionStorage.setItem(STORAGE_KEY, json);
    } catch {
      // ignore quota or parse errors
    }
  }

  getDraft(): MaterialEntryDraft | null {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw) as MaterialEntryDraft;
      if (!parsed?.formValue) return null;
      const principal = parsed.formValue.principal;
      if (principal && typeof principal.emissionDate === 'string') {
        parsed.formValue = { ...parsed.formValue, principal: { ...principal } };
        (parsed.formValue!.principal as any).emissionDate = new Date(principal.emissionDate);
      }
      return parsed;
    } catch {
      return null;
    }
  }

  clearDraft(): void {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {}
  }
}
